/* PC Praha (2. 11. 2026): graf „Vývoj ceny“ (sections/pcp-cena-vyvoj.liquid). Data = metapole pcp.cena_hist. */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  var MON = ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'];
  function kc(n) { return Math.round(n).toLocaleString('cs-CZ').replace(/ /g, ' ') + ' Kč'; }
  function kShort(n) { return n >= 1e6 ? (n / 1e6).toLocaleString('cs-CZ', { maximumFractionDigits: 1 }) + ' mil.' : n >= 1000 ? Math.round(n / 1000).toLocaleString('cs-CZ') + ' tis.' : String(Math.round(n)); }
  function dCz(d) { return d.getDate() + '. ' + (d.getMonth() + 1) + '. ' + d.getFullYear(); }
  function pct(a, b) { var p = (a - b) / b * 100; return (p > 0 ? '+' : p < 0 ? '−' : '') + Math.abs(p).toLocaleString('cs-CZ', { maximumFractionDigits: 0 }) + ' %'; }
  function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function nice(lo, hi) {
    var span = hi - lo || hi || 1, step = Math.pow(10, Math.floor(Math.log10(span / 3)));
    [1, 2, 2.5, 5, 10].some(function (m) { if (span / (step * m) <= 4) { step *= m; return true; } });
    return { lo: Math.floor(lo / step) * step, hi: Math.ceil(hi / step) * step, step: step };
  }

  function init(root) {
    if (root.dataset.cvOn) return;
    root.dataset.cvOn = '1';
    var data;
    try { data = JSON.parse(root.querySelector('[data-cv-data]').textContent); } catch (e) { return; }
    /* v2: týdenní řada od w0 ve stovkách Kč (cena = x × 100 − 1, null = bez ceníku), „now“ = dnešní cena na webu */
    var S = (data.s || []).map(function (s) {
      var p = [], w0 = new Date(s.w0 + 'T12:00:00').getTime();
      (s.v || []).forEach(function (x, i) { if (x != null) p.push({ d: new Date(w0 + i * 7 * 864e5), v: x * 100 - 1 }); });
      if (s.now) p.push({ d: new Date((data.upd || '') + 'T12:00:00'), v: s.now, now: 1 });
      return { l: s.l, hr: s.hr, p: p.filter(function (q) { return !isNaN(q.d); }) };
    }).filter(function (s) { return s.p.length > 1; });
    if (!S.length) { root.hidden = true; return; }
    var hr = parseFloat(root.dataset.hr), si = 0;
    S.forEach(function (s, i) { if (Math.abs(s.hr - hr) < 1e-6) si = i; });
    var range = 365;
    var svg = root.querySelector('[data-cv-svg]'), tip = root.querySelector('[data-cv-tip]'), plot = root.querySelector('[data-cv-plot]');
    var tabs = root.querySelector('[data-cv-tabs]');
    if (S.length > 1) {
      S.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = s.l; b.dataset.cvS = i;
        tabs.appendChild(b);
      });
    }
    var pts = [], geo = null;

    function stats(all, view) {
      var last = all[all.length - 1], box = root.querySelector('[data-cv-stats]');
      var yearAgo = null, t = last.d.getTime() - 365 * 864e5;
      for (var i = all.length - 1; i >= 0; i--) { if (all[i].d.getTime() <= t + 4 * 864e5) { yearAgo = all[i]; break; } }
      var lo = view.reduce(function (a, b) { return b.v < a.v ? b : a; }), hi = view.reduce(function (a, b) { return b.v > a.v ? b : a; });
      var rows = [
        ['Teď', kc(last.v), ''],
        ['Před rokem', yearAgo ? kc(yearAgo.v) : '–', yearAgo ? pct(last.v, yearAgo.v) + ' od té doby' : 'kratší historie'],
        ['Nejnižší', kc(lo.v), dCz(lo.d)],
        ['Nejvyšší', kc(hi.v), dCz(hi.d)]
      ];
      box.innerHTML = '';
      rows.forEach(function (r) {
        var w = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = r[0]; dd.textContent = r[1];
        if (r[2]) { var sm = document.createElement('small'); sm.textContent = r[2]; dd.appendChild(sm); }
        w.appendChild(dt); w.appendChild(dd); box.appendChild(w);
      });
      var desc = root.querySelector('[data-cv-desc]');
      if (desc) desc.textContent = 'Spojnicový graf ceny ' + S[si].l + ': nyní ' + kc(last.v) + (yearAgo ? ', před rokem ' + kc(yearAgo.v) : '') + ', minimum ' + kc(lo.v) + ', maximum ' + kc(hi.v) + '.';
    }

    function table(all) {
      var w = root.querySelector('[data-cv-table]'), t = document.createElement('table');
      t.innerHTML = '<thead><tr><th>Týden</th><th>Cena s DPH</th></tr></thead>';
      var tb = document.createElement('tbody');
      all.slice().reverse().forEach(function (p) { var tr = document.createElement('tr'); tr.innerHTML = '<td>' + (p.now ? 'dnes' : dCz(p.d)) + '</td><td>' + kc(p.v) + '</td>'; tb.appendChild(tr); });
      t.appendChild(tb); w.innerHTML = ''; w.appendChild(t);
    }

    function draw() {
      var all = S[si].p, end = all[all.length - 1].d.getTime();
      pts = range ? all.filter(function (p) { return p.d.getTime() >= end - range * 864e5; }) : all.slice();
      if (pts.length < 2) pts = all.slice(-2);
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      var W = svg.clientWidth || plot.clientWidth || 600, H = svg.clientHeight || 260;
      var vals = pts.map(function (p) { return p.v; });
      var n = nice(Math.min.apply(null, vals) * 0.96, Math.max.apply(null, vals) * 1.02);
      var L = 54, R = 10, T = 10, B = 26;
      var x0 = pts[0].d.getTime(), x1 = pts[pts.length - 1].d.getTime();
      function X(t) { return L + (t - x0) / ((x1 - x0) || 1) * (W - L - R); }
      function Y(v) { return T + (n.hi - v) / ((n.hi - n.lo) || 1) * (H - T - B); }
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      var defs = el('defs', {}, svg), g = el('linearGradient', { id: root.id + '-g', x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
      el('stop', { offset: '0%', 'stop-color': '#df1e2b', 'stop-opacity': '0.16' }, g);
      el('stop', { offset: '100%', 'stop-color': '#df1e2b', 'stop-opacity': '0' }, g);
      for (var v = n.lo; v <= n.hi + 1e-6; v += n.step) {
        el('line', { x1: L, x2: W - R, y1: Y(v), y2: Y(v), stroke: '#e9ecef', 'stroke-width': 1 }, svg);
        var tx = el('text', { x: L - 8, y: Y(v) + 4, 'text-anchor': 'end' }, svg); tx.textContent = kShort(v);
      }
      var months = [], d = new Date(pts[0].d.getFullYear(), pts[0].d.getMonth() + 1, 1);
      while (d.getTime() <= x1) { months.push(new Date(d)); d.setMonth(d.getMonth() + 1); }
      var every = Math.max(1, Math.ceil(months.length / Math.max(2, Math.floor((W - L) / 70))));
      months.forEach(function (m, i) {
        if (i % every) return;
        var t = el('text', { x: X(m.getTime()), y: H - 6, 'text-anchor': 'middle' }, svg);
        t.textContent = m.getMonth() === 0 || i === 0 ? MON[m.getMonth()] + ' ' + String(m.getFullYear()).slice(2) : MON[m.getMonth()];
      });
      var line = pts.map(function (p, i) { return (i ? 'L' : 'M') + X(p.d.getTime()).toFixed(1) + ' ' + Y(p.v).toFixed(1); }).join(' ');
      el('path', { d: line + ' L' + X(x1).toFixed(1) + ' ' + (H - B) + ' L' + L + ' ' + (H - B) + ' Z', fill: 'url(#' + root.id + '-g)' }, svg);
      el('path', { d: line, fill: 'none', stroke: '#df1e2b', 'stroke-width': 2, 'stroke-linejoin': 'round', 'stroke-linecap': 'round' }, svg);
      var lp = pts[pts.length - 1];
      el('circle', { cx: X(x1), cy: Y(lp.v), r: 4.5, fill: '#df1e2b', stroke: '#fff', 'stroke-width': 2 }, svg);
      var cross = el('line', { y1: T, y2: H - B, stroke: '#121417', 'stroke-width': 1, 'stroke-dasharray': '3 3', opacity: 0 }, svg);
      var dot = el('circle', { r: 5, fill: '#df1e2b', stroke: '#fff', 'stroke-width': 2, opacity: 0 }, svg);
      geo = { X: X, Y: Y, W: W, cross: cross, dot: dot };
      stats(S[si].p, pts);
      table(S[si].p);
      root.querySelectorAll('[data-cv-s]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.cvS === si)); });
      root.querySelectorAll('[data-cv-r]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.cvR === range)); });
    }

    function hover(clientX) {
      if (!geo || !pts.length) return;
      var r = svg.getBoundingClientRect(), x = (clientX - r.left) * (geo.W / r.width), best = pts[0], bd = 1e9;
      pts.forEach(function (p) { var dd = Math.abs(geo.X(p.d.getTime()) - x); if (dd < bd) { bd = dd; best = p; } });
      var px = geo.X(best.d.getTime()), py = geo.Y(best.v);
      geo.cross.setAttribute('x1', px); geo.cross.setAttribute('x2', px); geo.cross.setAttribute('opacity', 0.35);
      geo.dot.setAttribute('cx', px); geo.dot.setAttribute('cy', py); geo.dot.setAttribute('opacity', 1);
      tip.innerHTML = '<b>' + kc(best.v) + '</b>' + (best.now ? 'dnes – cena na webu' : 'týden od ' + dCz(best.d));
      tip.hidden = false;
      var scale = r.width / geo.W, left = px * scale + 12;
      if (left + tip.offsetWidth > r.width) left = px * scale - tip.offsetWidth - 12;
      tip.style.left = Math.max(0, left) + 'px';
      tip.style.top = Math.max(0, py * scale - 30) + 'px';
    }
    function leave() { if (!geo) return; tip.hidden = true; geo.cross.setAttribute('opacity', 0); geo.dot.setAttribute('opacity', 0); }

    svg.addEventListener('pointermove', function (e) { hover(e.clientX); });
    svg.addEventListener('pointerdown', function (e) { hover(e.clientX); });
    svg.addEventListener('pointerleave', leave);
    root.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.cvR != null) { range = +b.dataset.cvR; draw(); }
      if (b.dataset.cvS != null) { si = +b.dataset.cvS; draw(); }
    });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(draw, 150); });
    draw();
  }

  function run() { document.querySelectorAll('[data-pcp-cv]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();